import { PopoverContentContainer, PopoverRoot } from '@/components/Popover';
import { usePopover } from '@/hooks/popover/usePopover';
import InfoQuestionCircleIcon from '@/images/InfoQuestionCircle.svg';
import styled from '@emotion/styled';
import { FloatingArrow } from '@floating-ui/react';

const StyledPopoverContentContainer = styled(PopoverContentContainer.withComponent('ul'))`
    list-style-type: disc;
    list-style-position: inside;
`;

export const InstructionsTooltip = () => {
    const { isPopoverOpen, refs, floatingStyles, getFloatingProps, getReferenceProps, arrowProps } = usePopover({
        type: 'hover',
        options: { placement: 'top' },
        offsetOptions: { mainAxis: 15 },
    });

    return (
        <>
            <img src={InfoQuestionCircleIcon} alt="list item" width="12px" height="12px" ref={refs.setReference} {...getReferenceProps()} />

            {isPopoverOpen && (
                <PopoverRoot ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
                    <FloatingArrow {...arrowProps} />
                    <StyledPopoverContentContainer>
                        <li>Be specific and state the goal directly</li>
                        <li>Use simple language</li>
                        <li>Provide examples</li>
                        <li>Keep it brief</li>
                        <li>Stick to one request</li>
                    </StyledPopoverContentContainer>
                </PopoverRoot>
            )}
        </>
    );
};
